<template>
  <v-row class="mx-0 mt-0 mb-4">
    <v-col>
      <v-form
        lazy-validation
        @submit="confirmPayment()"
        onSubmit="return false;"
      >
        <Alert
          :message="error"
          type="error"
          v-if="showError"
          @toggleAlert="showError = !showError"
        />
        <Alert
          :message="success"
          type="success"
          v-if="showSuccess"
          @toggleAlert="showSuccess = !showSuccess"
        />

        <v-row>
          <v-col>
            <v-text-field
              ref="OTPInput"
              pt-0
              class="centered-input pinCodeInput"
              color="success"
              maxlength="6"
              :disabled="isPinCodeDisabled"
              v-model="pinCode"
              :rules="pincodeRules"
              :label="merchantConfig.texts.pinCodeTextFieldLabel"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <span class="caption codeSendToLbl">
              {{ $translate('CODESENTTO') }}
              {{ OTPDetails.otpDictionary.msisdn }}
            </span>
            <a @click="resendPin()" class="green--text caption">
              {{ $translate('RESENDPIN') }}
            </a>
            <v-progress-circular
              class="mx-1"
              :width="1"
              :size="15"
              v-if="sendingPinCode"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              elevation="0"
              block
              :disabled="!isButtonActive"
              :loading="loading"
              :rounded="templateConfig.isButtonRounded"
              class="mainButton"
              v-prevent-multiple-clicks:click="confirmPayment"
            >
              <span v-html="pinCodeBtnText" v-if="!loading"></span>
            </v-btn>
          </v-col>
        </v-row>
        <SecondaryDisclaimer v-if="pinCodeSecondaryDisclaimerText">
          <div
            v-html="pinCodeSecondaryDisclaimerText"
            class="secondryDisc"
          ></div>
        </SecondaryDisclaimer>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { confirmPaymentMixin } from './confirmPaymentMixin.js';
import simulateCodes from 'constants/simulateCodes';
import pincodeRules from '../../Shared/Rules/pincodeRules';
import SecondaryDisclaimer from '../../Shared/components/Disclaimer.vue';
import regex from '../../../constants/regex';
import Alert from '../../Shared/components/Alert.vue';

export default {
  mixins: [confirmPaymentMixin],
  components: { SecondaryDisclaimer, Alert },
  computed: {
    ...mapState(['templateConfig', 'OTPDetails', 'merchantConfig']),
    pinCodeBtnText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.pinCodeBtn;
    },
    pinCodeSecondaryDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.pinCodeSecondaryDisclaimer;
    },
    isButtonActive() {
      return this.pincodeRules[0](this.pinCode) === true;
    },
  },
  data() {
    return {
      sendingPinCode: false,
      showSuccess: false,
      showError: false,
      loading: false,
      error: '',
      success: '',
      pinCode: '',
      resendAttempts: 0,
      invalidPinCodeCount: 0,
      isPinCodeDisabled: false,
      pincodeRules: pincodeRules(this.$translate, regex.PINCODE),
    };
  },
  deactivated() {
    // reset the component before leave
    this.pinCode = '';
    this.$refs.OTPInput.isResetting = true; // access data of the OTPInput component
  },
  methods: {
    ...mapMutations(['setOTPDetails']),
    async resendPin() {
      this.resendAttempts++;

      if (this.resendAttempts > 4) {
        this.showSuccess = false;
        this.showErrorMessage(this.$translate('RESENDTRIALSEXCEEDED'));
      } else {
        this.sendingPinCode = true;
        let response = await this.$http.post('/otp/ResendVerificationPinCode', {
          transactionId: this.OTPDetails.otpDictionary.transactionId,
          simulate: process.env.NODE_ENV === 'development' ? true : false,
          SimulateStatusCode: simulateCodes.failed,
        });
        this.showError = false;
        this.showSuccess = false;

        if (response.data.statusCode == 1) {
          if (response.data.responseCode === 10) {
            this.showSuccess = true;
            this.success = this.$translate('PINCODESENTSUCCESS');
          } else {
            this.showErrorMessage(
              this.$translate('RESPONSECODE_' + response.data.responseCode)
            );
          }
        } else if (response.data.statusCode == 0) {
          this.moveToFailurePage(response.data.responseCode);
        }
        this.sendingPinCode = false;
      }
    },
  },
};
</script>
